webpackJsonp([79267323261768],{

/***/ 133:
/***/ (function(module, exports) {

	module.exports = function shortenUrl (url, maxLength) {
	  if (typeof url !== 'string') throw new TypeError('shorten-url: url must be a string')
	  if (typeof maxLength !== 'number') throw new TypeError('shorten-url: maxLength must be a number')
	
	  if (url.length < maxLength) return url
	
	  var scheme = /\w+:\/\//.exec(url)
	  if (scheme) {
	    scheme = scheme[0]
	    url = url.slice(scheme.length)
	  }
	
	  var i = url.indexOf('/')
	  var host
	  if (i === -1) {
	    host = url
	    url = ''
	  } else {
	    host = url.slice(0, i)
	    url = url.slice(i + 1)
	  }
	
	  var path
	  i = url.indexOf('?')
	  if (i === -1) {
	    path = url
	    url = ''
	  } else {
	    path = url.slice(0, i)
	    url = url.slice(i + 1)
	  }
	
	  var query = url
	
	  var parts = path.split('/')
	  var currentLength = scheme.length + host.length + path.length
	  var spliceIndex = -1
	  while (parts.length && currentLength > maxLength - 3) {
	    // Bias towards removing the start of a path vs the end
	    spliceIndex = Math.floor(parts.length / 2 - 1)
	    if (spliceIndex < 0) spliceIndex = 0
	
	    var part = parts.splice(spliceIndex, 1)
	    currentLength -= part[0].length + 1 /* the / */
	  }
	
	  if (spliceIndex !== -1) {
	    parts.splice(spliceIndex, 0, '…')
	  }
	
	  var newUrl = scheme + host + '/' + parts.join('/')
	  if (query) {
	    parts = query.split('&')
	    for (i = 0; i < parts.length; i++) {
	      if (currentLength + parts[i].length >= maxLength - 3) {
	        break
	      }
	      currentLength += parts[i].length
	    }
	    newUrl += '?' + parts.slice(0, i).join('&')
	    if (i < parts.length) {
	      if (i > 0) newUrl += '&'
	      newUrl += '…'
	    }
	  }
	
	  // If it's still too long, just chop some stuff off without caring about contents.
	  if (newUrl.length > maxLength) {
	    newUrl = newUrl.slice(0, maxLength - 1) + '…'
	  }
	
	  return newUrl
	}


/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (_ref) {
	  var givenName = _ref.givenName,
	      familyName = _ref.familyName,
	      imagePath = _ref.imagePath,
	      role = _ref.role,
	      children = _ref.children;
	
	  var roleHeading = role ? _react2.default.createElement(
	    'h4',
	    null,
	    (0, _breakParts.breakParts)(role.split('/'), '/')
	  ) : null;
	  var text = _react2.default.createElement(
	    'div',
	    { className: 'person__content' },
	    children
	  );
	  var image = imagePath ? _react2.default.createElement(
	    'div',
	    { className: 'person__photo' },
	    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)(imagePath), alt: 'photo of ' + givenName + ' ' + familyName, className: 'img-responsive img-rounded', itemProp: 'image' })
	  ) : null;
	  var slug = (givenName + '-' + familyName).toLowerCase().replace(/\s/g, '-');
	
	  return _react2.default.createElement(
	    'div',
	    { id: slug, className: 'row person', itemScope: true, itemType: 'http://schema.org/Person' },
	    _react2.default.createElement(
	      'div',
	      { className: 'person__textContent' },
	      _react2.default.createElement(
	        'h2',
	        { style: { marginBottom: role ? 0 : undefined } },
	        _react2.default.createElement(
	          'span',
	          { itemProp: 'givenName' },
	          givenName
	        ),
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { itemProp: 'familyName' },
	          familyName
	        )
	      ),
	      roleHeading,
	      text
	    ),
	    image
	  );
	};
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _breakParts = __webpack_require__(82);
	
	__webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (_ref) {
	  var url = _ref.url;
	
	  var truncatedUrl = (0, _shortenUrl2.default)(url, 60);
	  return _react2.default.createElement(
	    _link2.default,
	    { href: url },
	    _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(_icon2.default, { name: 'globe' }),
	      truncatedUrl
	    )
	  );
	};
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shortenUrl = __webpack_require__(133);
	
	var _shortenUrl2 = _interopRequireDefault(_shortenUrl);
	
	var _icon = __webpack_require__(43);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _link = __webpack_require__(10);
	
	var _link2 = _interopRequireDefault(_link);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.breakParts = breakParts;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function breakParts(parts, seperator) {
	  var l = parts.length;
	  return parts.map(function (a, i) {
	    return _react2.default.createElement(
	      'span',
	      { key: '' + i + a, style: { display: 'inline-block' } },
	      '' + a + (i < l - 1 ? seperator : '')
	    );
	  });
	}

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _person = __webpack_require__(80);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _twitter = __webpack_require__(59);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _website = __webpack_require__(81);
	
	var _website2 = _interopRequireDefault(_website);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Keynotes = function Keynotes() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'keynotes' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Keynotes'
	    ),
	    _react2.default.createElement(
	      _person2.default,
	      {
	        givenName: 'Ruth',
	        familyName: 'John',
	        imagePath: 'keynotes/ruth.jpg'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Ruth is a web technologist and Google Developer Expert. She likes to educate people about new web technologies and inspire them to try them, coming up with exciting and engaging ways to use them. She\u2019s a founding member of ',
	        _react2.default.createElement(
	          'span',
	          { style: { whiteSpace: 'nowrap' } },
	          '{',
	          ' Live: JS ',
	          '}'
	        ),
	        ', a collective of audio and visual artists that solely rely on JavaScript to create their performances. Her favourite things include hacking with hardware, evangelising about Web Audio and MIDI and taking her award nominated, hand coded, audio/visual software to the streets.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(_twitter2.default, { account: 'Rumyra' })
	      )
	    ),
	    _react2.default.createElement(
	      _person2.default,
	      {
	        givenName: 'Chris',
	        familyName: 'Rogers',
	        imagePath: 'keynotes/chris.jpg'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Chris Rogers is a software architect, specializing in audio production tools and music applications. Previously he worked at Google, where he developed the Web Audio API and other advanced web platform technologies. At Apple he was a principal designer of the Audio Units plugin architecture, and developed many of the ones shipping on Mac OS X and iOS, including the AUMatrixReverb, and the AUTimePitch time-stretching algorithm. He\'s also worked for Macromedia, Motorola, Wolfram Research, and IRCAM where he worked on SVP and developed the original AudioSculpt application.'
	      )
	    ),
	    _react2.default.createElement(
	      _person2.default,
	      {
	        givenName: 'Paul',
	        familyName: 'Adenot',
	        imagePath: 'keynotes/paul.jpg'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Paul Adenot is a platform engineer at Mozilla, working on the Firefox web browser. He is involved in Firefox Web Audio implementation, as well as the system audio code on all platforms, and occasionally helps on WebRTC. He also co-edits the Web Audio API specification at the W3C, and dabbles in music production.'
	      ),
	      _react2.default.createElement(_website2.default, { url: 'https://paul.cx/' })
	    )
	  );
	};
	
	exports.default = Keynotes;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-keynotes-js-8d62209a7c4c767617dd.js